import { scaffolderPlugin } from '@backstage/plugin-scaffolder';
import { createScaffolderFieldExtension } from '@backstage/plugin-scaffolder-react';
import { GithubRepoFilter } from './GithubRepoFilter';

export const GithubRepoFilterFieldExtension = scaffolderPlugin.provide(
  createScaffolderFieldExtension({
    name: 'GithubRepoFilter',
    component: GithubRepoFilter,
  }),
);
